import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Label } from '@folio/stripes-components';
import { useIntl } from 'react-intl';
import FieldGenerator from './FieldGenerator';

const propTypes = {
  formValues: PropTypes.arrayOf(PropTypes.object),
  formRenderProps: PropTypes.object,
  pageName: PropTypes.string,
  controlledVocab: PropTypes.object,
  actionType: PropTypes.string,
};

function FormFieldsGenerator({
  formValues,
  formRenderProps,
  pageName,
  controlledVocab,
  actionType,
}) {
  const { locale } = useIntl();

  // if (!formValues) {
  //   return <div>No fields found</div>;
  // }

  return (
    <>
      {formValues.map((section) => {
        return (
          <div key={section.sectionId}>
            <Accordion
              id={`template-form-generator-${section.sectionId}`}
              label={
                <Label fullWidth>
                  <h3>
                    {
                      section?.sectionLabel?.find(
                        (label) => label.locale === locale,
                      )?.value
                    }
                  </h3>
                </Label>
              }
            >
              {section?.sectionFields?.map((field, index) => {
                return (
                  <FieldGenerator
                    key={`${pageName}-field-generator-${section.sectionId}-${index}`}
                    fieldValues={field}
                    index={index}
                    locale={locale}
                    formRenderProps={formRenderProps}
                    pageName={pageName}
                    controlledVocab={controlledVocab}
                    actionType={actionType}
                  />
                );
              })}
            </Accordion>
          </div>
        );
      })}
    </>
  );
}

FormFieldsGenerator.propTypes = propTypes;

export default FormFieldsGenerator;
